import { createFileRoute } from '@tanstack/react-router';

import { ImagingPage } from '@/features/imaging';
export const Route = createFileRoute('/_authenticated/imaging/')({
  component: ImagingPage,
  beforeLoad: () => ({ breadcrumbs: [{ title: 'Imaging', href: '/imaging' }] }),
});
